import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export default function DraftRecoveryModal({ show, draft, onContinue, onStartFresh }) {
  return (
    <Modal show={show} onHide={onStartFresh} centered data-testid="rwm-wizard-recovery-modal">
      <Modal.Header closeButton>
        <Modal.Title>Continue where you left off?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        You have an unfinished draft
        {draft?.title ? `: "${draft.title}"` : ''}. Would you like to continue editing it?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onStartFresh} data-testid="rwm-wizard-recovery-new">
          Start fresh
        </Button>
        <Button variant="info" onClick={onContinue} data-testid="rwm-wizard-recovery-continue">
          Continue draft
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
